import React from 'react';
import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, Button, Card, Typography, Box } from '@mui/material';
import jwtAxios from "../../../../utils/jwtAxios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { AppColor } from "../../../../types/Constants";
import { CircularProgress } from '@mui/material';
import { useAppSelector } from "../../../../utils/hooks";
import { importBeacons } from "../../../../redux/actions/Beacon";
import { useAppDispatch } from "../../../../utils/hooks";

interface BeaconImportDialogProps {
  isOpen: boolean;
  onSubmitted: () => void;
  onClose: () => void;
}
const BeaconImportDialog: React.FC<BeaconImportDialogProps> = ({ isOpen, onClose, onSubmitted }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [error, setError] = useState<string>("");

    const businessGroupState = useAppSelector(state => state.businessGroup);
    const dispatch = useAppDispatch();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputFile = event.target.files![0];
    setSelectedFile(inputFile);
    setError("");
  };

  const handleImport = () => {
    if(selectedFile) {
        const group_id = businessGroupState.currentBusinessGroup?.id;
        const formData = new FormData();
        setIsLoading(true);

        formData.append('file', selectedFile, selectedFile.name);

        dispatch(importBeacons(group_id!, formData ,(result) => {
          if (result) {
            setSelectedFile(null);
            setError("");
            onSubmitted();
            onClose();
          }
          setIsLoading(false);
        }));
      }  
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setError("");
    onClose();
};

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle variant="h5" fontWeight="500">Import Beacons (.csv)</DialogTitle>
      <DialogContent>
        <Typography>You can create and update beacons in bulk by using a csv file.
        </Typography>
        <a href={require("../../../../utils/BeaconTemplate.csv")} download="Beacon Template"><Typography>Download csv file template</Typography></a>
        <Typography variant="h6" mt={4}>Upload</Typography>
        <Box mt={2}>
            <Box mt={1} sx={{float: "left"}}>
                <input type="file" accept=".csv" onChange={handleFileChange}/>
            </Box>
            <Box sx={{float: "right"}}>
                {isLoading ? (
                    <CircularProgress size="2rem" />
                ) : selectedFile ?(
                    <>
                    <Button sx={{marginRight: 2}} variant="outlined" onClick={handleCancel}>Cancel</Button>
                    <Button variant="contained" onClick={handleImport}>Import</Button>
                    </>
                ) : (
                    <>
                    <Button sx={{marginRight: 2}} variant="outlined" onClick={handleCancel}>Cancel</Button>
                    <Button disabled variant="contained" onClick={handleImport}>Import</Button>
                    </>
                )}
            </Box>
        </Box>
        {error && (
                    <Box sx={{float: "left"}}>
                    <Typography>{error}</Typography>
                    </Box>
                )}
      </DialogContent>
    </Dialog>
  );
};

export default BeaconImportDialog;
